module.exports = __webpack_public_path__ + "img/gameplay-screenshot.abc692e8.svg";